export default "__VITE_ASSET__CTmRmlVg__"